import get from 'lodash/get';
import { token } from '@atlaskit/tokens';
import type { Period } from '@atlassian/jira-platform-opsgenie-schedule';

export const backgroundColors = [
	token('color.chart.categorical.4', '#5E4DB2'),
	token('color.chart.categorical.5', '#943D73'),
	token('color.chart.categorical.2', '#09326C'),
	token('color.chart.categorical.7', '#50253F'),
	token('color.background.brand.boldest.pressed', '#0055CC'),
	token('color.chart.categorical.8', '#A54800'),
] as const;

export const assignColor = (name: string, colorMap: Map<string, string>) => {
	const cursor = colorMap.size % backgroundColors.length;

	if (colorMap.has(name)) {
		return colorMap.get(name) || backgroundColors[0];
	}
	const color = backgroundColors[cursor];
	colorMap.set(name, color);
	return color;
};

export const validPeriod = (period: Period): boolean =>
	get(period, 'recipient.type') !== 'noone' && !!get(period, 'recipient.name');
